module.exports = __webpack_public_path__ + "img/icon-accommodation.254ad879.svg";